export const ADDITIONAL_INFO_STEP_SECTION = 'addition-info-section';
export const ADDITIONAL_INFO_STEP_CONTINUE_BUTTON = 'addition-info-continue';
